module.exports = __webpack_public_path__ + "static/media/starshipit4_preview.d44c41a9.jpg";